import { ApiService } from '../../services'
export const CategoryModule = {
    namespaced: true,
    state: {
        request: null,
        length: 24,
        page: 1,
        total: 1,
        data: [],
        last_page: 1,
        searchTerm: null,
        filters: {},
    },
    actions: {

        resetData({dispatch}){  
            return new Promise((resolve, reject) => {
                dispatch('asyncGetData', 'item-master/category').then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            });
        },
        
        async asyncGetData({ state, commit},endpoint) {
            const { length, page, filters, searchTerm } = state
            return await new Promise((resolve, reject) => {

                commit('setLoading', true)
                const params = { length: length, page: page, term: searchTerm, filters: filters, view : 'furnishweb' }

                const configParams = {
                    req : "CategoryModule/req",
                    loadingTrue : "CategoryModule/loadingTrue",
                    addRequest : "CategoryModule/addRequest",
                    cancelRequest : "CategoryModule/cancelRequest",
                    clearOldRequest : "CategoryModule/clearOldRequest"
                }
                ApiService.get(endpoint, params, configParams).then((response) => {
                    commit('setData', response.data.map((i) => {
                        return i
                    }))
                    commit('setPage', response.data.page)
                    commit('setLastPage', response.data.to)
                    commit('setTotal', response.data.total)
                    resolve(response.data)
                    commit('setLoading', false)
                }).catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })

            })
        },

    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}

        },
        cancelRequest : (state) => {
            if(state.request != null){
                state.request.cancel()
            }
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setPage: (state, payload) => {
            state.page = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },
        setLength: (state, payload) => {
            state.length = payload
        },
        setLastPage: (state, payload) => {
            state.last_page = payload
        },
        setSearchTerm: (state, payload) => {
            state.searchTerm = payload
        },
    
        setFilters: (state, payload) => {
            state.filters = payload
        },
        setEmptyData: (state) => {
            state.data = []
        },


    },
    getters: {
        req: state => state.request,
        loading: state => state.loading,
        data: state => state.data,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        last_page : state => state.last_page
    }
}


